import s from './Loader.module.css'

export const Loader = () => <div className={s.loader}/>
